export default __webpack_public_path__ + "media/fonts/GOTHMBLA.woff2";